import React from 'react';
import { PointerGlow, QMark } from './motion';

// Shared hero for inner pages. `title` is an array of lines; wrap the accent word in {{ }}.
const renderLine = (s) => s.split(/(\{\{.*?\}\})/).map((p, i) =>
  p.startsWith('{{') ? <em key={i} className="text-[var(--red)]">{p.slice(2, -2)}</em> : p);

const PageHero = ({ index, eyebrow, title, children }) => (
  <section className="relative overflow-hidden pt-32 pb-6 lg:pt-36 lg:pb-8">
    <div className="absolute inset-0 grid-lines" />
    <PointerGlow />
    <QMark className="absolute -right-16 top-1/2 -translate-y-1/2 h-[135%] w-auto opacity-50 hidden md:block" />
    <div className="relative max-w-6xl mx-auto px-6">
      <p className="font-mono-label text-[var(--muted)] flex items-center gap-3 mb-8">
        <span className="text-[var(--red)]">{index}</span><span className="w-10 h-px bg-[var(--line-strong)]" />{eyebrow}
      </p>
      <h1 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.95] max-w-4xl">
        {title.map((line, i) => (<span key={i} className="line-mask"><span style={{ '--d': `${i * 120}ms` }}>{renderLine(line)}</span></span>))}
      </h1>
      <p className="mt-8 max-w-xl text-lg text-[var(--muted)] leading-relaxed reveal in" style={{ '--d': '500ms' }}>{children}</p>
    </div>
  </section>
);

export default PageHero;
